'use client';

import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const ANDRITZ_BLUE = '#0075be';
const MD = '@media (min-width: 768px)';

const linkSx = {
  fontWeight: 600,
  letterSpacing: '0.08em',
  fontSize: 14,
  color: '#fff',
  textDecoration: 'none',
  padding: '4px 8px',
  display: 'block',
  [MD]: { color: ANDRITZ_BLUE },
};

const Footer = () => (
  <Box sx={{ backgroundColor: ANDRITZ_BLUE, width: '100%', [MD]: { backgroundColor: 'transparent' } }}>
    <Box
      component="footer"
      sx={{
        padding: '8px 30px',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: 1220,
        mx: 'auto',
        [MD]: { color: ANDRITZ_BLUE },
      }}
    >
      <Box sx={{ letterSpacing: '0.08em', fontWeight: 800 }}>© ANDRITZ {new Date().getFullYear()}</Box>

      <Box component="ul" sx={{ display: 'flex', flexDirection: 'row', gap: 1, m: 0, p: 0 }}>
        <Box component="li" sx={{ listStyle: 'none' }}>
          <Box
            component="a"
            href="https://www.andritz.com/group-en/privacy-policy/imprint"
            target="_blank"
            rel="noreferrer"
            sx={linkSx}
          >
            Imprint
          </Box>
        </Box>
        <Box component="li" sx={{ listStyle: 'none' }}>
          <Box
            component="a"
            href="https://www.andritz.com/group-en/privacy-policy"
            target="_blank"
            rel="noreferrer"
            sx={linkSx}
          >
            Data privacy declaration
          </Box>
        </Box>
        <Box component="li" sx={{ listStyle: 'none' }}>
          <Box
            component="a"
            href="https://www.andritz.com/group-en/cookies"
            target="_blank"
            rel="noreferrer"
            sx={linkSx}
          >
            Cookies policy
          </Box>
        </Box>
      </Box>

      <Box component="ul" sx={{ display: 'flex', m: 0, p: 0 }}>
        <Box component="li" sx={{ listStyle: 'none' }}>
          <Box component="a" href="http://www.youtube.com/c/AndritzGroup" target="_blank" rel="noreferrer" sx={linkSx}>
            <YouTubeIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>
        <Box component="li" sx={{ listStyle: 'none' }}>
          <Box
            component="a"
            href="https://www.linkedin.com/company/andritz"
            target="_blank"
            rel="noreferrer"
            sx={linkSx}
          >
            <LinkedInIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default Footer;
